export function generateShopTestSeries(data, name, onLegendItemClick = null) {
  return {
    name: name,
    type: "spline",
    data: data,
    color: "var(--kdiagram-shoptest-color)",
    marker: {
      enabled: false,
    },
    events: {
      legendItemClick: onLegendItemClick
    },
    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
    visible: false,
  };
}
